// import defaultContent from "../default";
import { iconsSet as icons } from "../../../../assets/icons/icons";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_robstrader.png",
      alt: "Estratégias RobsTrader",
    },
    title: "Opere com a RobsTrader",

    // String ou array de strings
    text: [
      "Há 5 anos no mercado e a  2 anos desenvolvendo operações automatizadas a Robs Trader conta com um time de traders com mais de 10 anos de experiência em mercado financeiro, voltado para day trade.",
      "Pensando em otimizar o seu tempo, diversificar seus investimentos, estar em um mercado de alta performance e ter consistência no day trade que automatizamos todas as nossas estratégias e reunimos em portfólios onde todas trabalham ao mesmo tempo em uma única plataforma, e o melhor, 100% automatizado! ",
      "Se você quer todos esses benefícios e ainda lucrar com isso, estamos à sua disposição! ",
    ],
    testimonial: {
      text: "O caminho mais simples para alcançar a consistência é o fator risco ganho, gerando sustentabilidade no médio e longo prazo.",
      author: {
        name: "Fernando Bastos, sócio proprietário Robs Trader.",
        picture: "",
      },
    },
  },

  strategies: {
    title: "Portfólios Robs Trade",
    heading:
      "Opere diversas estratégias ao mesmo tempo em uma única plataforma.",
    subtitle:
      "Nossas melhores estratégias automatizadas para diversificar seus investimentos em um mercado de alta performance.",
  },

  tableRobsTrader: true,

  cta: {
    title: "Conheça todos os nossos portfólios e",
    subtitle: "escolha o que mais se encaixa no seu perfil.",
    buttonText: "Quero escolher meu portfólio",
  },

  about: {
    title: "Sobre a empresa",
    subtitle: "A RobsTrader",
    col1: [
      "Formada por um time de traders com mais de 10 anos de experiência no mercado financeiro, a Robs Trader iniciou suas atividades em 2018 com mentorias presenciais, chegando a ter mais de 600 alunos. Em 2020 pensando em operar diversas estratégias ao mesmo tempo e diversificar os investimentos foi que os mentores decidiram automatizar seus melhores operacionais.",
      "Utilizando a estatística, foram desenvolvidas estratégias voltadas para o mercado futuro, reunidas em portfólios para operações automatizadas no mercado brasileiro a B3; sendo o nosso DNA o risco ganho favorável e baixa exposição.",
    ],
    col2: [
      "Temos mais de 500 pessoas operando as nossas estratégias e diversificando conosco nesse mercado de alta performance; temos todo o nosso histórico de operações em conta real lastreada pela Trader Analyzer.",
    ],
  },

  stats: {
    title: "Nossos números",
    // subtitle:
    //   "Nascemos para simplificar a vida do investidor e trazer tranquilidade e clareza em cada operação.",
    data: [
      {
        value: "+5",
        description: "Anos em atividade",
      },
      {
        value: "+500",
        description: "Pessoas utilizando as nossas estratégias",
      },
      {
        value: "+2000",
        description: "Contratos negociados diariamente",
      },
    ],
  },

  features: {
    title: "Por que utilizar os robôs da RobsTrader?",
    subtitle: "Veja quais as principais vantagens.",
    data: [
      {
        icon: icons.favorite,
        title: "Emocional",
        description:
          "Os robôs não tem emoções, são programados para seguir a risca as estratégias traçadas.",
      },
      {
        icon: icons.clock,
        title: "Tempo",
        description:
          "Não é necessário ficar em frente a tela acompanhando as operações, os robôs trabalham por você.",
      },
      {
        icon: icons.pie_chart,
        title: "Diversificação",
        description:
          "É uma boa forma de diversificar seus investimentos, podendo utilizar várias estratégias dentro de um mesmo portfólio, diluindo o risco e tendo sustentabilidade a médio e longo prazo.",
      },
      {
        icon: icons.lightning,
        title: "100% automático",
        description:
          "Não é necessário acessar a plataforma; não é necessário ficar na frente do computador e nem em deixar em nuvem, todas as estratégias são desenvolvidas de acordo com a ordem emitida de uma central.",
      },
      {
        icon: icons.click,
        title: "Acompanhamento em tempo real",
        description:
          "Acompanhe todas as operações desenvolvidas pelo seu portfólio, através do celular,computador, ou grupo exclusivo de resultados.",
      },
      {
        icon: icons.test_tube,
        title: "Backtest",
        description:
          "Todas as estratégias são testadas com dados históricos recentes, com equipamentos de alta qualidade, garantindo o melhor gerenciamento sempre visando o risco ganho favorável.",
      },
      // ...defaultContent.features.data,
    ],
  },

  plans: {
    title: "Planos",
    subtitle:
      "Conheça os planos da RobsTrader e veja qual se adequa melhor ao seu perfil.",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
